exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ActivationCodesPreferences a{cursor:pointer}.ActivationCodesPreferences .school-select{margin-top:40px;margin-bottom:40px}.ActivationCodesPreferences .school-select b{margin-bottom:5px}.ActivationCodesPreferences .bulk-entry .action{margin-top:5px;float:right;margin-bottom:20px}.ActivationCodesPreferences .bulk-entry .action a{margin-right:5px}.ActivationCodesPreferences .code-table .infoTooltip{margin-left:3px;display:inline}.ActivationCodesPreferences .code-table .name-field{display:inline-block;width:50%;margin:0}.ActivationCodesPreferences .code-table .status{color:#2f4f4f}.ActivationCodesPreferences .code-table .edit{background-color:#d3d3d3}.ActivationCodesPreferences .code-table .remove{color:#cd5c5c}.ActivationCodesPreferences .code-table .sent{background-color:#f0f8ff}.ActivationCodesPreferences .code-table .error{background-color:rgba(255,163,0,.7098039216)}.ActivationCodesPreferences .sending-alert{margin-top:5px;color:#cd5c5c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/org/preferences/activation_codes_preferences.scss
// module id = 1326
// module chunks = 0